import React from "react";
import { Link } from "react-router-dom";

const Carousel = () => {
  return (
    <div
      id="myCarousel"
      className="carousel slide home-slider-section"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner home-slider">
        <div className="carousel-item active home-banner-items">
          <img
            src="https://res.cloudinary.com/debltnmge/image/upload/f_auto,q_auto/ym4j6rphl7qz6khjzbsv"
            alt="Demo1"
            className="banner-inner-wrap"
          />
          <div className="carousel-caption banner-content-wrap">
            <div className="container">
              <div className="banner-content text-center">
                <h3 className="banner-title">JOURNEY TO HIDDEN PARADISES</h3>
                <p>
                  Embark on a mesmerizing journey through hidden paradises with
                  JourneyScape, where untouched beauty and serenity await.
                  Traverse lush valleys, where vibrant blooms paint a
                  picturesque landscape, revealing hidden waterfalls and
                  crystal-clear pools.
                </p>
                <Link to="/About" className="btn btn-primary button-primary">
                About JourneyScape
             </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item home-banner-items">
          <img
            src="https://res.cloudinary.com/debltnmge/image/upload/f_auto,q_auto/f630k38y6dteshvyc3su"
            alt="Demo2"
            className="banner-inner-wrap"
          />
          <div className="carousel-caption banner-content-wrap">
            <div className="container">
              <div className="banner-content text-center">
                <h3 className="banner-title">UNTOUCHED SPLENDOR OF PAKISTAN</h3>
                <p>
                  Experience the untouched splendor of Pakistan, where
                  breathtaking landscapes and hidden treasures await. Immerse
                  yourself in a world of awe-inspiring beauty, creating
                  unforgettable memories that will stir your soul.
                </p>
                <Link to="/About" className="btn btn-primary button-primary">
                About JourneyScape
             </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item home-banner-items">
          <img
            src="https://res.cloudinary.com/debltnmge/image/upload/f_auto,q_auto/oh87dyotw1csz9heppnm"
            alt="Demo3"
            className="banner-inner-wrap"
          />
          <div className="carousel-caption">
            <div className="container">
              <div className="banner-content text-center">
                <h3 className="banner-title">TRAVELLING AROUND THE WORLD</h3>
                <p>
                  Embark on a global adventure, traversing continents and
                  cultures, as you indulge in the joy of traveling around the
                  world. Discover new horizons, forge unforgettable connections,
                  and unlock the boundless wonders that await your exploration.
                </p>
                <Link to="/About" className="btn btn-primary button-primary">
                About JourneyScape
             </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide="prev"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide="next"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default Carousel;
